import React from 'react'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { IssueLabel } from '../../../../components/entities/IssueLabel'
import { ConvertibleLabel } from '../../../../components/entities/ConvertibleLabel'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { IssueEntity } from 'types/IssueEntity'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { IssuesGroupEntity } from 'types/IssuesGroupEntity'
import { Issue } from 'types/Issue'
import { Convertible } from 'types/Convertible'

export function IssueGroups({
    issue,
    convertible,
    entitiesInGroups,
    handleDeleteFromGroup,
    handleAddToGroup,
}: {
    handleAddToGroup: (groupId: string, issue: IssueEntity | null, convertible: ConvertibleEntity | null) => void
    handleDeleteFromGroup: (groupId: string, group: IssuesGroupEntity<Issue> | IssuesGroupEntity<Convertible>) => void
    issue: IssueEntity | null
    convertible: ConvertibleEntity | null
    entitiesInGroups: Record<string, Array<IssuesGroupEntity<Issue> | IssuesGroupEntity<Convertible>>>
}) {
    return (
        <>
            <Typography variant='body2'>Länkgrupper</Typography>
            <List>
                {Object.entries(entitiesInGroups).map(([groupId, entities]) => {
                    const isInGroup = entities.some(
                        (entity) => entity.issueId === issue?.id || entity.convertibleId === convertible?.id,
                    )
                    return (
                        <ListItem key={groupId} sx={{ border: 'dotted 1px', borderRadius: 3 }}>
                            <Stack direction='column' spacing={1}>
                                {!isInGroup && (
                                    <Tooltip title='Lägg till i gruppen'>
                                        <IconButton onClick={() => handleAddToGroup(groupId, issue, convertible)}>
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {isInGroup && (
                                    <Tooltip title='Ta bort från gruppen'>
                                        <IconButton
                                            onClick={() => handleDeleteFromGroup(groupId, issue || convertible)}
                                        >
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Stack>
                            <List>
                                {entities.map((entity) => (
                                    <ListItem key={`${groupId}_${entity.issueId || entity.convertibleId}`}>
                                        {entity.issueId ? (
                                            <Typography variant='body2'>
                                                <IssueLabel adminLink issue={entity} />{' '}
                                                {issue?.id === entity.issueId && ' (aktuell emission)'}
                                            </Typography>
                                        ) : null}
                                        {entity.convertibleId ? (
                                            <Typography variant='body2'>
                                                <ConvertibleLabel adminLink convertible={entity} />{' '}
                                                {convertible?.id === entity.convertibleId && ' (aktuell konvertibel)'}
                                            </Typography>
                                        ) : null}
                                    </ListItem>
                                ))}
                            </List>
                        </ListItem>
                    )
                })}
            </List>
        </>
    )
}
